import { useTranslation } from 'react-i18next';
import { RequestStatus } from '@magimp/shared';
import { Icon } from '../../../ui/index.js';
import type { RequestView } from '../types.js';

export function RequestDrawerReturnBanner({ r }: { r: RequestView }) {
  const { t } = useTranslation('requests');
  if (r.status !== RequestStatus.RETURN || !r.returnReason) return null;
  // WHY: warn tokens (ochre) instead of error/red — the RETURN status
  //   pill is neutral, so the banner stops doubling severity while
  //   still signaling "action needed". Body text stays in --fg-1 so
  //   the operator's free-text reason remains normally readable.
  return (
    <div
      style={{
        margin: '12px 24px 0',
        padding: '12px 14px',
        background: 'var(--status-warn-bg)',
        borderRadius: 'var(--r-2)',
        display: 'flex',
        gap: 10,
        flex: 'none',
      }}
    >
      <Icon
        name="alert-triangle"
        size={16}
        style={{ color: 'var(--status-warn-fg)', flex: 'none', marginTop: 1 }}
      />
      <div>
        <div
          style={{
            fontSize: 12,
            fontWeight: 600,
            color: 'var(--status-warn-fg)',
            marginBottom: 2,
          }}
        >
          {t('tabs.returnBanner')}
        </div>
        <div style={{ fontSize: 13, color: 'var(--fg-1)' }}>{r.returnReason}</div>
      </div>
    </div>
  );
}
